/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { debounce } from 'lodash';
import Input from './Input';
import { formControlContainer } from '@assets/styles/formStyles';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { INPUT_HEIGHT, CHECK_SIZE } from '@/constants';
import Image from '@components/global/Image';
import FormLabel from '@components/form/common/FormLabel';
import FormError from '@components/form/common/FormError';
import FormOverlay from '@components/form/common/FormOverlay';
import FormValueMultiple from '@components/form/common/FormValueMultiple';
import FormInputContainer from '@components/form/common/FormInputContainer';
import FormArrow from '@components/form/common/FormArrow';
import SociollaText from '@components/sociolla/SociollaText';
import ModalHalf from '@components/modal/ModalHalf';
import { Loader } from '@components/screen/Layout';
import PropTypes from 'prop-types';

const propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
  ]),
  editable: PropTypes.bool,
  multiple: PropTypes.bool,
  label: PropTypes.string,
  labelKey: PropTypes.string,
  formLabelKey: PropTypes.string,
  trackBy: PropTypes.string,
  options: PropTypes.array,
  isDropdown: PropTypes.bool,
  hideLabel: PropTypes.bool,
  isMap: PropTypes.string,
  arrayOne: PropTypes.bool,
  withCallback: PropTypes.bool,
  withLoadMore: PropTypes.bool,
  loadMoreEmpty: PropTypes.bool,
  loading: PropTypes.bool,
  loadingCallback: PropTypes.bool,
  limit: PropTypes.number,
  buttonAction: PropTypes.bool,
  withReset: PropTypes.bool,
  hideSearch: PropTypes.bool,
  isGroup: PropTypes.bool,
};

const defaultProps = {
  value: '',
  editable: true,
  multiple: false,
  label: '',
  labelKey: '',
  formLabelKey: '',
  trackBy: '',
  options: [],
  isDropdown: false,
  hideLabel: false,
  isMap: '',
  arrayOne: false,
  withCallback: false,
  withLoadMore: false,
  loadMoreEmpty: false,
  loading: false,
  loadingCallback: false,
  limit: 10,
  buttonAction: false,
  withReset: false,
  isGroup: false,
};

const getItem = (item, key) => {
  if (key && key.indexOf('.') > -1) {
    try {
      return key.split('.').reduce((o, i) => o[i], item);
    } catch (error) {
      return item[key];
    }
  }
  return item[key];
};

const checkValue = (value, key) => {
  return typeof value == 'object' && key ? getItem(value, key) : value;
};

const SelectBoxsDefault = (props) => {
  const {
    value = '',
    editable = true,
    multiple: isMultiple = false,
    label = '',
    labelKey = '',
    formLabelKey = '',
    trackBy = '',
    options = [],
    isDropdown = false,
    hideLabel = false,
    isMap = '',
    arrayOne = false,
    withCallback = false,
    withLoadMore = false,
    loadMoreEmpty = false,
    loading = false,
    loadingCallback = false,
    limit = 10,
    buttonAction = false,
    withReset = false,
    hideSearch = false,
    isGroup = false,
  } = props;

  const dropdownRef = useRef();
  const [showSelectBox, setShowSelectBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [formValue, setFormValue] = useState('');
  const [newOption, setNewOption] = useState([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      let position_height = 0;
      const newOptionsValue = (options?.length ? options : []).map((item) => {
        const newItem = { ...item };
        newItem.position_height = position_height;
        position_height += isWeb ? 44 : 50;
        if (isGroup) {
          for (let i = 0; i < newItem.data.length; i++) {
            newItem.data[i].position_height = position_height;
            position_height += isWeb ? 44 : 50;
          }
        }
        return newItem;
      });
      if (value) {
        if (isMultiple) {
          setInputValue(value);
        } else {
          // const convertNewValue = (val) =>
          //   formLabelKey
          //     ? checkValue(val, formLabelKey)
          //     : checkValue(val, labelKey);
          const convertNewValue = (val) => {
            if (formLabelKey) {
              return checkValue(val, formLabelKey);
            } else {
              return checkValue(val, labelKey);
            }
          };
          const tempValue = convertNewValue(value);
          let check = newOptionsValue.find(
            (c) => tempValue == convertNewValue(c),
          );
          if (isGroup) {
            for (let i = 0; i < newOptionsValue.length; i++) {
              const item = newOptionsValue[i];
              const checkChild = item.data.find(
                (c) => tempValue == convertNewValue(c),
              );
              if (checkChild) {
                check = checkChild;
              }
            }
          }
          if (check) {
            setInputValue(check);
          } else {
            setInputValue(tempValue);
          }
        }
      } else {
        if (isMultiple) {
          setInputValue([]);
        } else {
          setInputValue('');
        }
      }
      setNewOption(newOptionsValue);
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  useEffect(() => {
    let mounted = true;
    if (mounted && showSelectBox) {
      setTimeout(() => {
        if (inputValue && dropdownRef?.current) {
          try {
            dropdownRef?.current?.scrollTo({
              y: inputValue?.position_height || 0,
              animated: true,
            });
          } catch (err) {}
        }
      }, 100);
      if (withCallback) {
        try {
          setKeyword('');
          props.onReady();
        } catch (error) {}
      }
    }
    return () => {
      mounted = false;
    };
  }, [showSelectBox]);

  // show label into the form
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const finalValue = isMultiple
        ? inputValue && inputValue.length
          ? ' '
          : ''
        : formLabelKey
        ? checkValue(inputValue, formLabelKey)
        : checkValue(inputValue, labelKey);
      setFormValue(finalValue?.toString() || '');
    }
    return () => {
      mounted = false;
    };
  }, [inputValue]);

  // on search address
  const onSearchAddress = async (val) => {
    if (val && props.mapApi && isMap) {
      setIsLoading(true);
      try {
        const response = await props.mapApi({
          params: {
            filter: {
              input: val,
              limit: 10,
            },
          },
        });
        if (response.data.data.results.length) {
          const finalList = response.data.data.results.map((a) => {
            let name = '';
            let latitude = '';
            let longitude = '';
            if (isMap == 'google') {
              name = a.name + ' ' + a.formatted_address;
              latitude = a.geometry.location.lat;
              longitude = a.geometry.location.lng;
            }
            if (isMap == 'osm') {
              name = a.display_name;
              latitude = a.lat;
              longitude = a.lon;
            }
            return {
              id: a.place_id,
              name,
              latitude,
              longitude,
            };
          });
          setNewOption([...finalList]);
        }
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    }
  };

  // handling selected value
  const handleValue = (value) => {
    try {
      const finalValue = Object.assign({}, value);
      const oldValue = inputValue;
      if (isMultiple) {
        const findIndex = inputValue.findIndex(
          (data) =>
            checkValue(data, trackBy) == checkValue(finalValue, trackBy),
        );
        const arrayValue = JSON.parse(JSON.stringify(inputValue));
        if (findIndex == -1) {
          arrayValue.push(finalValue);
        } else {
          arrayValue.splice(findIndex, 1);
        }
        props.onChange(arrayValue, oldValue);
        setInputValue(arrayValue);
        if (arrayOne) {
          setShowSelectBox(false);
        }
      } else {
        props.onChange(finalValue, oldValue);
        setInputValue(finalValue);
        setShowSelectBox(false);
      }
    } catch (error) {
      setShowSelectBox(false);
    }
  };

  const onResetValue = () => {
    const oldValue = inputValue;
    const lastValue = isMultiple ? [] : '';
    setInputValue(lastValue);
    props.onChange(lastValue);
    if (props.onReset) {
      props.onReset(oldValue);
    }
    setShowSelectBox(false);
  };

  const onCallback = (value) => {
    props.onChange(value);
    setInputValue(value);
  };

  const onSearch = useCallback(
    debounce((val, paramOptions) => doSearch(val, paramOptions), 500),
    [],
  );

  // on search option list
  const doSearch = (val, paramOptions = []) => {
    const realKeyword = val ? val.toLowerCase() : '';
    if (isMap) {
      // if searching map address
      onSearchAddress(val);
    } else if (withCallback) {
      // if we have callback for fetch data from api
      try {
        props.searchCallback(val);
      } catch (error) {}
    } else {
      // search without fetch api
      if (val) {
        const filtered = paramOptions.filter((item) => {
          const realValue = item[labelKey] ? item[labelKey].toLowerCase() : '';
          return realValue.indexOf(realKeyword) > -1;
        });
        setNewOption(filtered);
      } else {
        setNewOption(paramOptions);
      }
    }
  };

  // load more callback
  const onLoadMore = () => {
    try {
      props.onLoadMore(keyword);
    } catch (err) {}
  };

  // option item component
  const OptionItem = ({ item, index }) => {
    const checkSelectedList = (checkItem) => {
      let result = false;
      const selectedValue = JSON.parse(JSON.stringify(checkItem));

      if (isMultiple) {
        if (inputValue && inputValue.length) {
          const findData = (inputValue || []).find(
            (val) =>
              checkValue(val, trackBy) == checkValue(selectedValue, trackBy),
          );
          if (findData) {
            result = true;
          }
        }
      } else {
        if (inputValue) {
          result =
            checkValue(inputValue, trackBy) ==
            checkValue(selectedValue, trackBy);
        }
      }

      return result;
    };

    return (
      <TouchableOpacity
        activeOpacity={0.6}
        style={[
          styles.optionItem,
          {
            borderBottomColor:
              index == (newOption || []).length - 1
                ? 'transparent'
                : Colors.grey0,
          },
        ]}
        onPress={() => handleValue(item)}>
        <View style={styles.checklist}>
          {checkSelectedList(item) ? (
            <Image
              style={CHECK_SIZE}
              width={CHECK_SIZE.width}
              height={CHECK_SIZE.height}
              svg={true}
              source={require('@assets/img/icons/check-circle-blue.svg')}
            />
          ) : (
            false
          )}
        </View>
        <SociollaText>{labelKey ? item[labelKey] : item}</SociollaText>
      </TouchableOpacity>
    );
  };

  // .....menu view
  const OptionList = () => (
    <>
      {(isMap && isLoading) || loading ? (
        <Loader />
      ) : !loadingCallback && !loading && !(newOption || []).length ? (
        <View style={styles.noDataList}>
          <SociollaText style={styles.optionText}>No data found</SociollaText>
        </View>
      ) : (
        <>
          {isGroup
            ? (newOption || []).map((item, idx) => (
                <View key={idx}>
                  <TouchableOpacity
                    activeOpacity={0.8}
                    style={[styles.optionItem, styles.optionItemGroup]}>
                    <SociollaText
                      type="medium"
                      style={styles.optionItemGroupText}>
                      {item.refrence_code}
                    </SociollaText>
                  </TouchableOpacity>
                  {(item.data || []).map((child, childIdx) => (
                    <OptionItem key={childIdx} index={childIdx} item={child} />
                  ))}
                </View>
              ))
            : (newOption || []).map((item, idx) => (
                <OptionItem key={idx} index={idx} item={item} />
              ))}
        </>
      )}
      {withCallback && withLoadMore && !loadMoreEmpty ? (
        <>
          {loadingCallback ? (
            <Loader />
          ) : (newOption || []).length >= limit ? (
            <TouchableOpacity
              activeOpacity={0.6}
              onPress={() => onLoadMore()}
              style={styles.loadMoreButton}>
              <SociollaText style={styles.optionText}>Load More</SociollaText>
            </TouchableOpacity>
          ) : (
            false
          )}
        </>
      ) : (
        false
      )}
    </>
  );

  return (
    <>
      <View style={[{ position: 'relative' }, props.selectContainer]}>
        <FormOverlay
          {...props}
          onCallback={() =>
            editable ? setShowSelectBox(!showSelectBox) : false
          }
        />
        {/* Start Input Container */}
        {editable && !isMultiple ? (
          // Input Container for editable and not multiselect
          <Input
            {...props}
            label={hideLabel ? '' : label}
            inputContainerStyle={{ height: INPUT_HEIGHT }}
            value={formValue}
            editable={false}
            isSelectBox={true}
            rightIcon={<FormArrow {...props} />}
          />
        ) : (
          // Input Container when its not editable or multiselect
          <View
            style={{
              ...formControlContainer,
              ...props.containerStyle,
            }}>
            <FormLabel {...props} />
            <FormInputContainer {...props} value={formValue} />
            <FormError {...props} />
          </View>
        )}
        {/* End Input Container */}
        {/* Start Result Container */}
        {isMultiple ? (
          <FormValueMultiple {...props} onChange={(val) => onCallback(val)} />
        ) : (
          false
        )}
        {/* End Result Container */}
        {/* Start Options List as Dropdown */}
        {isDropdown && showSelectBox ? (
          <ScrollView
            ref={dropdownRef}
            style={[styles.dropMenu, hideLabel || !label ? { top: 40 } : {}]}>
            <OptionList></OptionList>
          </ScrollView>
        ) : (
          false
        )}
        {/* End Options List as Dropdown */}
      </View>
      {/* Start Options List as Popup */}
      <ModalHalf
        scrollRef={dropdownRef}
        title={label}
        visible={showSelectBox && !isDropdown}
        onClose={() => setShowSelectBox(false)}
        maxWidth={isWeb ? 450 : '100%'}
        spaceFromTop={isWeb ? '10%' : false}
        headerBordered={true}
        searchInput={
          // Search Input on Popup
          hideSearch ? (
            <></>
          ) : (
            <>
              <View style={styles.modalOptions}>
                <Input
                  label=""
                  placeholder="Search something here..."
                  value={keyword}
                  onChangeText={(val) => {
                    setKeyword(val);
                    if (!buttonAction) {
                      onSearch(val, options);
                    }
                  }}
                  rightIcon={
                    buttonAction ? (
                      <TouchableOpacity
                        activeOpacity={0.6}
                        style={styles.searchBtn}
                        onPress={() =>
                          keyword && keyword.length > 4
                            ? onSearch(keyword, options)
                            : false
                        }>
                        <Image
                          style={styles.searchWhite}
                          width={12}
                          height={12}
                          svg={true}
                          source={require('@assets/img/icons/search-white.svg')}
                        />
                      </TouchableOpacity>
                    ) : (
                      <Image
                        style={styles.searchGrey}
                        width={16}
                        height={16}
                        svg={true}
                        source={require('@assets/img/icons/search.svg')}
                      />
                    )
                  }
                />
              </View>
              {withReset && (isMultiple ? inputValue?.length : inputValue) ? (
                <View style={styles.reset}>
                  <TouchableOpacity
                    activeOpacity={0.6}
                    style={styles.resetItem}
                    onPress={() => onResetValue()}>
                    <SociollaText style={styles.resetText}>Reset</SociollaText>
                  </TouchableOpacity>
                </View>
              ) : (
                false
              )}
            </>
          )
        }
        children={<OptionList />}
      />
      {/* End Options List as Popup */}
    </>
  );
};

const styles = StyleSheet.create({
  dropMenu: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 7,
    elevation: 1,
    position: 'absolute',
    left: 0,
    right: 0,
    top: 68,
    backgroundColor: '#fff',
    zIndex: 3,
    borderRadius: 4,
    maxHeight: isWeb ? 200 : 100,
  },
  searchBtn: {
    height: 33,
    borderRadius: 4,
    backgroundColor: Colors.blue3,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    position: 'absolute',
    right: 0,
    top: 0,
    marginRight: -16,
    marginTop: 4,
    width: 50,
  },
  optionItem: {
    width: '100%',
    paddingHorizontal: 15,
    paddingVertical: isWeb ? 13 : 17,
    borderBottomWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  optionItemGroup: {
    backgroundColor: Colors.grey0,
    borderBottomColor: Colors.grey0,
  },
  optionItemGroupText: { color: Colors.grey1 },
  optionText: { fontSize: 13 },
  checklist: {
    width: CHECK_SIZE.width + 1,
    height: CHECK_SIZE.width + 1,
    borderRadius: CHECK_SIZE.width + 1,
    borderColor: Colors.grey0,
    borderWidth: 1,
    marginRight: 15,
  },
  noDataList: {
    width: '100%',
    paddingHorizontal: 15,
    paddingVertical: 25,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  loadMoreButton: {
    width: '100%',
    paddingTop: 15,
    paddingBottom: 5,
    paddingHorizontal: 20,
    justifyContent: 'center',
    alignItems: 'center',
    borderTopColor: Colors.grey0,
    borderTopWidth: 1,
  },
  modalOptions: {
    width: '100%',
    paddingHorizontal: 15,
    paddingVertical: 10,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  searchWhite: { width: 12, height: 12 },
  searchGrey: { width: 16, height: 16 },
  reset: { width: '100%', textAlign: 'right' },
  resetItem: {
    textAlign: 'right',
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  resetText: { fontSize: 13, color: Colors.red0 },
});

SelectBoxsDefault.propTypes = propTypes;
SelectBoxsDefault.defaultProps = defaultProps;

export default React.memo(SelectBoxsDefault, (prev, next) => prev == next);
